import React, { useState, useEffect } from 'react';
import AdminSubPage from '../components/AdminSubPage';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import api from '../lib/api';

const PREFIXES = [
  { key: 'client', label: 'Client', defaultPrefix: 'CL', example: 'CL00001' },
  { key: 'loan', label: 'Loan Account', defaultPrefix: 'LN', example: 'LN00001' },
  { key: 'savings', label: 'Savings Account', defaultPrefix: 'SA', example: 'SA260413001' },
  { key: 'share', label: 'Share Account', defaultPrefix: 'SH', example: 'SH260413001' },
  { key: 'lease', label: 'Lease Account', defaultPrefix: 'LS', example: 'LS00001' },
  { key: 'group', label: 'Group', defaultPrefix: 'GRP', example: 'GRP0001' },
  { key: 'center', label: 'Center', defaultPrefix: 'CTR', example: 'CTR0001' },
  { key: 'employee', label: 'Employee', defaultPrefix: 'EMP', example: 'EMP0001' },
  { key: 'group_savings', label: 'Group Savings', defaultPrefix: 'GSV', example: 'GSV260413001' },
  { key: 'group_share', label: 'Group Share Investment', defaultPrefix: 'GSH', example: 'GSH260413001' },
];

const AccountNumberPrefsPage = () => {
  const [prefs, setPrefs] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);
  const load = async () => {
    setLoading(true);
    try { const res = await api.get('/account-number-preferences'); setPrefs(res.data || {}); }
    catch (e) { setPrefs({}); }
    setLoading(false);
  };

  const handleSave = async () => {
    try { await api.put('/account-number-preferences', prefs); toast.success('Preferences saved'); }
    catch (e) { toast.error('Failed to save'); }
  };

  return (
    <AdminSubPage title="Account Number Preferences" breadcrumb={['Admin', 'System', 'Account Number Preferences']} backPath="/dashboard/admin/system" actionLabel="Save" onAction={handleSave}>
      <p className="text-sm text-gray-500 mb-4">Configure the prefix for auto-generated account numbers across all entity types.</p>
      {loading ? <div className="text-center py-8 text-gray-400">Loading...</div> : (
        <div className="bg-white border border-gray-200 divide-y">
          {PREFIXES.map(p => (
            <div key={p.key} className="flex items-center justify-between px-6 py-4" data-testid={`anp-row-${p.key}`}>
              <div>
                <div className="text-sm font-medium text-[#1f1f1f]">{p.label}</div>
                <div className="text-xs text-gray-400">Example: {p.example}</div>
              </div>
              <div className="flex items-center gap-2">
                <Input
                  value={prefs[`${p.key}_prefix`] ?? p.defaultPrefix}
                  onChange={e => setPrefs({...prefs, [`${p.key}_prefix`]: e.target.value})}
                  placeholder={p.defaultPrefix}
                  className="w-24 text-center text-sm font-mono"
                  data-testid={`anp-${p.key}`}
                />
                <span className="text-xs text-gray-400">+ auto number</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </AdminSubPage>
  );
};
export default AccountNumberPrefsPage;
